import React, {useContext, useEffect, useState} from 'react';
import {PAContext} from "../../../Services/PAContext";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent, timelineOppositeContentClasses,
    TimelineSeparator
} from "@mui/lab";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {Box, Divider, Menu, MenuItem} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FlightDialogEditCosts from "./FlightDialogEditCosts";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import dayjs from "dayjs";





function FlightCard({this_flight, openStatusPicker, setShowAccountDialog, openDeleteDialog}) {

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage, removeFirstFlightStatusActions } = useContext(PAContext);
    const { Account, FlightStatusPipeline, authenticated } = dataArray;

    const [eventFlight, setEventFlight] = useState(this_flight);

    useEffect(() => {
        if (FlightStatusPipeline.length === 0) return; // Prevent unnecessary runs

        FlightStatusPipeline.forEach(_incoming => {

            if (_incoming.result === "ok") {
                if (_incoming.action === "E_getFlightStatusResults") {
                    try {
                        // 1. Check if this specific message is for THIS flight card
                        if (_incoming.statusData && String(_incoming.statusData.flight_id) === String(eventFlight.id)) {

                            console.log(`Updating Flight ${eventFlight.id} with live status...`);

                            const _status_data = _incoming.statusData;

                            // 2. Update local state so the UI (Pulsing Dot, Gates, etc.) refreshes
                            setFlightStatus(_status_data.status);

                            setEventFlight(prev => ({
                                ...prev,
                                status: _status_data.status,
                                status_timestamp: _status_data.status_timestamp,
                                depart_terminal: _status_data.depart_terminal,
                                depart_gate: _status_data.depart_gate,
                                arrive_terminal: _status_data.arrive_terminal,
                                arrive_gate: _status_data.arrive_gate,
                                baggage_claim: _status_data.baggage_claim,
                                delay_minutes: _status_data.delay_minutes
                            }));

                            // 3. Remove the action from the pipeline so other cards don't process it
                            removeFirstFlightStatusActions();

                            // 4. Stop the manual refresh spinner if it was active
                            setIsRefreshing(false);
                        }
                    } catch (e){}

                }

            }

        });
    }, [FlightStatusPipeline]);

    const formatTimestamp = (timestamp, timezone) => {
        const date = new Date(timestamp);

        // Use Intl.DateTimeFormat to format the time in the correct timezone
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timezone,
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,  // to get 12-hour format with AM/PM
            timeZoneName: 'short' // to get timezone abbreviation like "EDT"
        });

        return formatter.format(date);
    };

    const [flightStatus, setFlightStatus] = useState(this_flight.status || "Scheduled");
    const [isRefreshing, setIsRefreshing] = useState(false);


    // Cirium Status Codes:
    // L = Landed, C = Cancelled, D = Diverted, NO = Not Operational
    const isFlightComplete = ['L', 'C', 'D', 'NO', 'Missed'].includes(this_flight.status);

    // Alternatively, if status is missing, check if the arrival time is in the past
    const isPastFlight = dayjs(this_flight.arrive_timestamp).add(1, 'hour').isBefore(dayjs());

    const shouldHideControls = isFlightComplete || isPastFlight;


    // Toggle Alerts Handler
    const handleToggleAlerts = () => {
        setEventFlight((prev) => ({
            ...prev,
            alerts_enabled: !prev.alerts_enabled
        }));
    };

    const handleManualRefresh = () => {
        if (isRefreshing) return; // Prevent double-clicks

        setIsRefreshing(true);

        const departDate = dayjs(eventFlight.depart_timestamp);

        sendSocketMessage({
            action: "E_getFlightStatus",
            event_id: PA_GlobalObject.Planning.id,
            flight_id: eventFlight.id,
            airline_id: eventFlight.airline_code,
            flight_number: eventFlight.flight_number,
            depart_date_year: departDate.year(),
            depart_date_month: departDate.month() + 1,
            depart_date_day: departDate.date()
        });

        // Reset the spinning icon after 2 seconds (or when the socket returns)
        setTimeout(() => setIsRefreshing(false), 2000);
    };



    const [anchorFlightItemMenu, setAnchorFlightItemMenu] = useState(null);
    const handleFlightListItemMenuOpenMenu = (event) => {
        setAnchorFlightItemMenu(event.currentTarget);
    };
    const handleFlightListItemMenuClose = () => {
        setAnchorFlightItemMenu(null);
    };

    const [isFlightDialogEditCostsOpen, setFlightDialogEditCostsOpen] = useState(false);

    useEffect(() => {
        console.log("eventFlight has been triggered --- : ");

        if (JSON.stringify(this_flight) === JSON.stringify(eventFlight)) {
            return;
        }

        // Find the current flight in global store
        const currentFlight = usePA_GlobalStore
            .getState()
            .PA_GlobalObject
            .Planning
            .flights
            .find((a) => a.id === eventFlight.id);

        // Do a deep equality check before proceeding
        if (JSON.stringify(currentFlight) === JSON.stringify(eventFlight)) {
            console.log("eventFlight has NOT been updated !!!");
            return; // No meaningful change, so skip update
        }

        console.log("eventFlight has been updated --- : ", eventFlight);

        // Just update the flight
        set_PA_GlobalObject((prev) => {
            const updatedFlights = prev.Planning.flights.map((_flight) =>
                _flight.id === eventFlight.id
                    ? { ..._flight, ...eventFlight }
                    : _flight
            );

            return {
                Planning: {
                    ...prev.Planning,
                    flights: updatedFlights,
                },
            };
        });



        if (PA_GlobalObject.Planning.status !== 10) {
            const departDate = dayjs(eventFlight.depart_timestamp);

            const _sendString = {
                action: "E_updateEventFlight_v2",
                event_id: PA_GlobalObject.Planning.id,
                // Wrap details in a flight object to match server expectations
                flight: {
                    flight_id: eventFlight.id,
                    airline_id: eventFlight.airline_code, // e.g., "AA"
                    flight_number: eventFlight.flight_number,
                    depart_airport_code: eventFlight.depart_airport_code,
                    arrive_airport_code: eventFlight.arrive_airport_code,
                    depart_date_year: departDate.year(),
                    depart_date_month: departDate.month() + 1, // JS months are 0-indexed
                    depart_date_day: departDate.date(),
                    amount_total: eventFlight.amount_total,
                    currency: eventFlight.currency,
                    is_business_expense: eventFlight.attendee.is_business_expense,
                    business_expense_amount: eventFlight.attendee.business_expense_amount,
                    attendee_id: eventFlight.attendee.id, // Crucial for permission check
                    alerts_enabled : eventFlight.alerts_enabled,
                    status: eventFlight.status,
                    status_timestamp: eventFlight.status_timestamp,
                }
            };

            console.log("%%%%%% _sendString", _sendString);

            sendSocketMessage(_sendString);
        }

    }, [eventFlight, this_flight]);


    const getStatusColor = (status) => {
        const colors = {
            'Scheduled': '#757575',
            'On Time': '#2e7d32',
            'Delayed': '#d32f2f',
            'Landed': '#1976d2',
            'Arrived': '#1976d2',
            'Cancelled': '#e74c3c',
            'Missed': '#94a3b8', // 👈 Added Missed color option
            'Diverted': '#ef6c00',
            'S': '#757575',
            'L': '#1976d2',
            'C': '#e74c3c'
        };
        return colors[status] || '#757575';
    };

    return (

        <>
            {(() => {

                return (
                    <>
                        {/* Header: Status Bar */}
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            p: '8px 16px',
                            background: shouldHideControls
                                ? 'linear-gradient(90deg, #f8f9fa 0%, #eceff1 100%)' // Muted background for archived
                                : 'linear-gradient(90deg, #ffffff 0%, #f0f4f8 100%)',
                            borderBottom: '1px solid #e0e6ed',
                            borderRadius: '16px 16px 0 0',
                            mb: 1
                        }}>
                            {/* Left Side: Status with Pulsing Dot */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Box sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    bgcolor: getStatusColor(flightStatus),
                                    position: 'relative',
                                    // Disable pulse if flight is finished or just scheduled
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '50%',
                                        animation: (shouldHideControls || flightStatus?.toLowerCase() === 'scheduled') ? 'none' : 'pulse 2s infinite',
                                        boxShadow: `0 0 0 0 ${getStatusColor(flightStatus)}77`,
                                    },
                                    '@keyframes pulse': {
                                        '0%': { transform: 'scale(0.95)', boxShadow: `0 0 0 0 ${getStatusColor(flightStatus)}77` },
                                        '70%': { transform: 'scale(1)', boxShadow: `0 0 0 10px ${getStatusColor(flightStatus)}00` },
                                        '100%': { transform: 'scale(0.95)', boxShadow: `0 0 0 0 ${getStatusColor(flightStatus)}00` },
                                    }
                                }} />
                                <Typography sx={{
                                    fontSize: '12px',
                                    fontWeight: 800,
                                    color: shouldHideControls ? '#90a4ae' : '#37474f',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                }}>
                                    {shouldHideControls && flightStatus === 'L' ? 'ARRIVED' : flightStatus}
                                </Typography>
                            </Box>

                            {/* Right Side: Alerts Logic (Hidden if Finished) */}
                            {!shouldHideControls ? (
                                Account.email ? (
                                    <Box
                                        onClick={handleToggleAlerts}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 0.8,
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: '20px',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            bgcolor: eventFlight.alerts_enabled ? '#e3f2fd' : 'transparent',
                                            border: eventFlight.alerts_enabled ? '1px solid #bbdefb' : '1px solid #cfd8dc',
                                            '&:hover': { bgcolor: eventFlight.alerts_enabled ? '#bbdefb' : '#f5f5f5' }
                                        }}
                                    >
                                        <i className={eventFlight.alerts_enabled ? "icon-notification" : "icon-notification-off"}
                                           style={{
                                               fontSize: '14px',
                                               color: eventFlight.alerts_enabled ? '#1976d2' : '#90a4ae',
                                           }}
                                        />
                                        <Typography sx={{
                                            fontSize: '11px',
                                            color: eventFlight.alerts_enabled ? '#1976d2' : '#90a4ae',
                                            fontWeight: 700,
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {eventFlight.alerts_enabled ? 'LIVE ALERTS ON' : 'ALERTS OFF'}
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => setShowAccountDialog(true)}
                                        sx={{
                                            display: 'flex', alignItems: 'center', gap: 0.6, px: 1.2, py: 0.4,
                                            borderRadius: '16px', bgcolor: '#fff5f5', border: '1px solid #feb2b2', cursor: 'pointer'
                                        }}
                                    >
                                        <i className="icon-warning" style={{ fontSize: '11px', color: '#c53030' }} />
                                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#c53030' }}>
                                            EMAIL REQ.
                                        </Typography>
                                    </Box>
                                )
                            ) : (
                                /* Show simple badge for archived flights instead of toggle */
                                <Box sx={{ px: 1.5, py: 0.5, borderRadius: '20px', border: '1px solid #cfd8dc', opacity: 0.6 }}>
                                    <Typography sx={{ fontSize: '10px', color: '#90a4ae', fontWeight: 700 }}>FLIGHT ARCHIVED</Typography>
                                </Box>
                            )}
                        </Box>

                        {/* Sub-header with Refresh and Timestamp (Hidden if Finished) */}
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            px: 2, mt: -0.5, mb: 1, gap: 0.5,
                            visibility: shouldHideControls ? 'hidden' : 'visible' // Keep layout spacing but hide content
                        }}>
                            <Typography variant="caption" sx={{ fontSize: '9px', color: '#90a4ae', fontStyle: 'italic' }}>
                                {eventFlight.status_timestamp
                                    ? `Last updated: ${dayjs(eventFlight.status_timestamp).format('h:mm A')}`
                                    : 'Schedule confirmed'}
                            </Typography>

                            <IconButton size="small" onClick={handleManualRefresh} sx={{ p: 0.5 }}>
                                <i className={`icon-cw ${isRefreshing ? 'spinner-animate' : ''}`}
                                   style={{ fontSize: '10px', color: isRefreshing ? '#1976d2' : '#90a4ae' }}
                                />
                            </IconButton>
                        </Box>
                    </>
                );
            })()}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <IconButton
                    aria-label="more"
                    onClick={handleFlightListItemMenuOpenMenu}
                >
                    <i className="icon-menu2" style={{fontSize:'16px'}} />
                </IconButton>
                <Menu
                    anchorEl={anchorFlightItemMenu}
                    open={Boolean(anchorFlightItemMenu)}
                    onClose={handleFlightListItemMenuClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    PaperProps={{
                        sx: {
                            width: '320px',
                            borderRadius: '16px',
                            mt: 1.5,
                            boxShadow: '0px 10px 25px rgba(21, 18, 105, 0.12)',
                            border: '1px solid #f1f3f5',
                            overflow: 'visible',
                            '&:before': { // Small arrow pointing to the button
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        }
                    }}
                >
                    {/* MENU HEADER */}
                    <Box sx={{ px: 2.5, py: 1.5, bgcolor: '#f8f9fa', borderRadius: '16px 16px 0 0', mb: 1 }}>
                        <Typography sx={{ fontSize: '10px', fontWeight: 900, color: '#95a5a6', letterSpacing: 1 }}>
                            FLIGHT MANAGEMENT
                        </Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: 800, color: '#151269' }}>
                            {eventFlight.flight_number} • {eventFlight.depart_airport_code} to {eventFlight.arrive_airport_code}
                        </Typography>
                    </Box>

                    {/* MANUAL STATUS UPDATE */}
                    <MenuItem
                        onClick={() => { handleFlightListItemMenuClose(); openStatusPicker(); }}
                        sx={{ mx: 1, borderRadius: '10px', py: 1.2 }}
                    >
                        <ListItemIcon sx={{
                            minWidth: '40px !important',
                            height: '32px',
                            width: '32px',
                            borderRadius: '8px',
                            bgcolor: 'rgba(25, 118, 210, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mr: 1.5
                        }}>
                            <i className="icon-pencil" style={{ fontSize: '16px', color: '#1976d2' }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Update Status / Times"
                            secondary="Manual override"
                            primaryTypographyProps={{ fontWeight: 700, color: '#2c3e50', fontSize: '14px' }}
                            secondaryTypographyProps={{ fontSize: '11px', fontWeight: 600 }}
                        />
                    </MenuItem>

                    {/* EDIT COST */}
                    <MenuItem
                        onClick={() => { handleFlightListItemMenuClose(); setFlightDialogEditCostsOpen(true); }}
                        sx={{ mx: 1, borderRadius: '10px', py: 1.2 }}
                    >
                        <ListItemIcon sx={{
                            minWidth: '40px !important',
                            height: '32px',
                            width: '32px',
                            borderRadius: '8px',
                            bgcolor: 'rgba(5, 150, 105, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mr: 1.5
                        }}>
                            <i className="icon-wallet" style={{ fontSize: '16px', color: '#059669' }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Edit Cost"
                            secondary={`${eventFlight.amount_total} ${eventFlight.currency}`}
                            primaryTypographyProps={{ fontWeight: 700, color: '#2c3e50', fontSize: '14px' }}
                            secondaryTypographyProps={{ fontSize: '11px', fontWeight: 800, color: '#059669' }}
                        />
                    </MenuItem>

                    <Divider sx={{ my: 1, mx: 2, borderColor: '#f1f3f5' }} />

                    {/* DELETE ACTION */}
                    <MenuItem
                        onClick={() => { handleFlightListItemMenuClose(); openDeleteDialog(eventFlight); }}
                        sx={{
                            mx: 1,
                            borderRadius: '10px',
                            py: 1.2,
                            color: '#e74c3c',
                            '&:hover': {
                                backgroundColor: '#fff5f5',
                                color: '#c0392b'
                            }
                        }}
                    >
                        <ListItemIcon sx={{ color: 'inherit', minWidth: '40px !important', mr: 1.5, display: 'flex', justifyContent: 'center' }}>
                            <i className="icon-trash" style={{ fontSize: '18px' }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Delete Flight"
                            primaryTypographyProps={{ fontWeight: 700, fontSize: '14px' }}
                        />
                    </MenuItem>
                </Menu>

            </Box>

            <Box>
                <Timeline sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                        flex: 0.2,
                    },
                }}>
                    <TimelineItem>
                        <TimelineOppositeContent>
                            <Typography variant="caption" color="textSecondary">
                                Depart
                            </Typography>
                        </TimelineOppositeContent>

                        <TimelineSeparator>
                            <TimelineDot color="success">
                                <i className="icon-airplane" style={{ fontSize: '1rem' }} />
                            </TimelineDot>
                            <TimelineConnector />
                        </TimelineSeparator>

                        <TimelineContent>
                            <Typography variant="subtitle2" color="textSecondary">
                                {formatTimestamp(eventFlight.depart_timestamp, eventFlight.depart_timezone)}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ fontWeight: 700 }}>
                                    {eventFlight.depart_airport_name} ({eventFlight.depart_airport_code})
                                </Typography>
                            </Box>
                            <Typography variant="body2" color="textSecondary">
                                {(eventFlight.airline_name)} ({eventFlight.flight_number})
                            </Typography>

                            {/* Dynamic Gate/Terminal Badge */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ bgcolor: '#e8f5e9', px: 1, borderRadius: '4px', border: '1px solid #c8e6c9', display: 'flex', gap: 1 }}>
                                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#1976d2' }}>
                                        TERM {eventFlight.depart_terminal}
                                    </Typography>
                                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#2e7d32' }}>
                                        GATE {eventFlight.depart_gate}
                                    </Typography>
                                </Box>
                            </Box>

                            {(() => {
                                // 1. Calculate Duration (Actual air time)
                                const depTime = new Date(eventFlight.depart_timestamp).getTime() - (eventFlight.depart_timezone_offset * 3600000);
                                const arrTime = new Date(eventFlight.arrive_timestamp).getTime() - (eventFlight.arrive_timezone_offset * 3600000);
                                const diffMs = arrTime - depTime;

                                // Safety check for invalid dates
                                if (isNaN(diffMs) || diffMs < 0) return null;

                                const hours = Math.floor(diffMs / 3600000);
                                const minutes = Math.floor((diffMs % 3600000) / 60000);

                                // 2. Calculate Timezone Offset
                                const offsetDiff = eventFlight.arrive_timezone_offset - eventFlight.depart_timezone_offset;
                                const tzDisplay = offsetDiff > 0 ? `+${offsetDiff}h` : `${offsetDiff}h`;

                                return (
                                    <Box sx={{
                                        my: 1.5,
                                        py: 1,
                                        px: 1.5,
                                        borderLeft: '2px dashed #1565c0',
                                        bgcolor: '#f8fbff',
                                        borderRadius: '0 8px 8px 0',
                                        width: 'fit-content'
                                    }}>
                                        <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', fontWeight: 700, color: 'text.primary' }}>
                                            <i className="icon-clock" style={{ marginRight: '6px', fontSize: '12px', color: '#1565c0' }} />
                                            {hours}h {minutes}m
                                        </Typography>

                                        {/* Only show if there is an actual offset difference */}
                                        {offsetDiff !== 0 && (
                                            <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', mt: 0.5, fontWeight: 600, color: '#d32f2f', fontSize: '10px' }}>
                                                <i className="icon-earth" style={{ marginRight: '6px', fontSize: '12px' }} />
                                                TIMEZONE CHANGE: {tzDisplay}
                                            </Typography>
                                        )}
                                    </Box>
                                );
                            })()}

                            {/* Show Delay Warning if applicable */}
                            {eventFlight.delay_minutes > 0 && (
                                <Typography variant="caption" sx={{ color: '#d32f2f', fontWeight: 700 }}>
                                    <i className="icon-warning" style={{ fontSize: '10px', marginRight: '4px' }} />
                                    {eventFlight.delay_minutes}m Delay
                                </Typography>
                            )}
                        </TimelineContent>
                    </TimelineItem>

                    <TimelineItem>
                        <TimelineOppositeContent>
                            <Typography variant="caption" color="textSecondary">
                                Arrive
                            </Typography>
                        </TimelineOppositeContent>

                        <TimelineSeparator>
                            <TimelineDot color="success">
                                <i className="icon-airplane" style={{ fontSize: '1rem', transform: 'rotate(90deg)' }} />
                            </TimelineDot>
                        </TimelineSeparator>

                        <TimelineContent>
                            <Typography variant="subtitle2" color="textSecondary">
                                {formatTimestamp(eventFlight.arrive_timestamp, eventFlight.arrive_timezone)}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {(eventFlight.arrive_airport_name)} ({eventFlight.arrive_airport_code})
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {/* NEW: Arrival Gate & Baggage Badge */}
                                <Box sx={{ bgcolor: '#e8f5e9', px: 1, borderRadius: '4px', border: '1px solid #c8e6c9', display: 'flex', gap: 1 }}>
                                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#1976d2' }}>
                                        TERM {eventFlight.arrive_terminal}
                                    </Typography>
                                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#2e7d32' }}>
                                        GATE {eventFlight.arrive_gate}
                                    </Typography>
                                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#ef6c00' }}>
                                        BELT {eventFlight.baggage_claim}
                                    </Typography>
                                </Box>
                            </Box>
                        </TimelineContent>
                    </TimelineItem>
                </Timeline>
            </Box>


            {/* Edit Flight Costs Dialog */}
            <FlightDialogEditCosts
                isOpen={isFlightDialogEditCostsOpen}
                onClose={() => setFlightDialogEditCostsOpen(false)}
                eventFlight={eventFlight}
                setEventFlight={setEventFlight}
            />
        </>

    );

}

export default FlightCard;
